// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9fYNj","title":"styles_title__oIvCJ","description":"styles_description__A3dzu","hiddenInput":"styles_hiddenInput__xkFij"};